/**
 * NativeWaves Org API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class OrganizationsApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of organizations (you have access to).
     */
    async organizationsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of organizations (you have access to).
     */
    async organizationsGet(requestParameters = {}, initOverrides) {
        const response = await this.organizationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an organization and all its child resources.
     */
    async organizationsOrganizationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an organization and all its child resources.
     */
    async organizationsOrganizationIdDelete(requestParameters, initOverrides) {
        await this.organizationsOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an organization.
     */
    async organizationsOrganizationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an organization.
     */
    async organizationsOrganizationIdGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of guests.
     */
    async organizationsOrganizationIdGuestsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdGuestsGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling organizationsOrganizationIdGuestsGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/guests`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of guests.
     */
    async organizationsOrganizationIdGuestsGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdGuestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a guest.
     */
    async organizationsOrganizationIdGuestsGuestIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdGuestsGuestIdGet.');
        }
        if (requestParameters.guestId === null ||
            requestParameters.guestId === undefined) {
            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling organizationsOrganizationIdGuestsGuestIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/guests/{guestId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'guestId'}}`, String(requestParameters.guestId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a guest.
     */
    async organizationsOrganizationIdGuestsGuestIdGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdGuestsGuestIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of invitations.
     */
    async organizationsOrganizationIdInvitationsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdInvitationsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invitations`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of invitations.
     */
    async organizationsOrganizationIdInvitationsGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdInvitationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdDelete.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invitations/{invitationId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdDelete(requestParameters, initOverrides) {
        await this.organizationsOrganizationIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdGet.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invitations/{invitationId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.organizationRoleRamInvitationEdit === null ||
            requestParameters.organizationRoleRamInvitationEdit === undefined) {
            throw new runtime.RequiredError('organizationRoleRamInvitationEdit', 'Required parameter requestParameters.organizationRoleRamInvitationEdit was null or undefined when calling organizationsOrganizationIdInvitationsInvitationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invitations/{invitationId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationRoleRamInvitationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an invitation.
     */
    async organizationsOrganizationIdInvitationsInvitationIdPatch(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new invitation.
     */
    async organizationsOrganizationIdInvitationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdInvitationsPost.');
        }
        if (requestParameters.organizationRoleRamInvitationInsert === null ||
            requestParameters.organizationRoleRamInvitationInsert === undefined) {
            throw new runtime.RequiredError('organizationRoleRamInvitationInsert', 'Required parameter requestParameters.organizationRoleRamInvitationInsert was null or undefined when calling organizationsOrganizationIdInvitationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/invitations`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationRoleRamInvitationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new invitation.
     */
    async organizationsOrganizationIdInvitationsPost(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of members.
     */
    async organizationsOrganizationIdMembersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdMembersGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling organizationsOrganizationIdMembersGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/members`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of members.
     */
    async organizationsOrganizationIdMembersGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a member.
     */
    async organizationsOrganizationIdMembersMemberIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdMembersMemberIdDelete.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling organizationsOrganizationIdMembersMemberIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/members/{memberId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a member.
     */
    async organizationsOrganizationIdMembersMemberIdDelete(requestParameters, initOverrides) {
        await this.organizationsOrganizationIdMembersMemberIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a member.
     */
    async organizationsOrganizationIdMembersMemberIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdMembersMemberIdGet.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling organizationsOrganizationIdMembersMemberIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/members/{memberId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a member.
     */
    async organizationsOrganizationIdMembersMemberIdGet(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdMembersMemberIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a member.
     */
    async organizationsOrganizationIdMembersMemberIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdMembersMemberIdPatch.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling organizationsOrganizationIdMembersMemberIdPatch.');
        }
        if (requestParameters.organizationRoleRamMemberEdit === null ||
            requestParameters.organizationRoleRamMemberEdit === undefined) {
            throw new runtime.RequiredError('organizationRoleRamMemberEdit', 'Required parameter requestParameters.organizationRoleRamMemberEdit was null or undefined when calling organizationsOrganizationIdMembersMemberIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/members/{memberId}`
                .replace(`{${'organizationId'}}`, String(requestParameters.organizationId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationRoleRamMemberEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a member.
     */
    async organizationsOrganizationIdMembersMemberIdPatch(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdMembersMemberIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new member.
     */
    async organizationsOrganizationIdMembersPostRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdMembersPost.');
        }
        if (requestParameters.organizationRoleRamMemberInsert === null ||
            requestParameters.organizationRoleRamMemberInsert === undefined) {
            throw new runtime.RequiredError('organizationRoleRamMemberInsert', 'Required parameter requestParameters.organizationRoleRamMemberInsert was null or undefined when calling organizationsOrganizationIdMembersPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/members`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationRoleRamMemberInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new member.
     */
    async organizationsOrganizationIdMembersPost(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an organization.
     */
    async organizationsOrganizationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdPatch.');
        }
        if (requestParameters.organizationEdit === null ||
            requestParameters.organizationEdit === undefined) {
            throw new runtime.RequiredError('organizationEdit', 'Required parameter requestParameters.organizationEdit was null or undefined when calling organizationsOrganizationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an organization.
     */
    async organizationsOrganizationIdPatch(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Transfer the organization ownership from you to another organization member.
     */
    async organizationsOrganizationIdTransferOwnershipPostRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling organizationsOrganizationIdTransferOwnershipPost.');
        }
        if (requestParameters.organizationOwnershipTransfer === null ||
            requestParameters.organizationOwnershipTransfer === undefined) {
            throw new runtime.RequiredError('organizationOwnershipTransfer', 'Required parameter requestParameters.organizationOwnershipTransfer was null or undefined when calling organizationsOrganizationIdTransferOwnershipPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/transferOwnership`.replace(`{${'organizationId'}}`, String(requestParameters.organizationId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationOwnershipTransfer,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Transfer the organization ownership from you to another organization member.
     */
    async organizationsOrganizationIdTransferOwnershipPost(requestParameters, initOverrides) {
        const response = await this.organizationsOrganizationIdTransferOwnershipPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new organization.
     */
    async organizationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationInsert === null ||
            requestParameters.organizationInsert === undefined) {
            throw new runtime.RequiredError('organizationInsert', 'Required parameter requestParameters.organizationInsert was null or undefined when calling organizationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new organization.
     */
    async organizationsPost(requestParameters, initOverrides) {
        const response = await this.organizationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const OrganizationsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const OrganizationsOrganizationIdGuestsGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
/**
 * @export
 */
export const OrganizationsOrganizationIdMembersGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
//# sourceMappingURL=OrganizationsApi.js.map